<template>
  <ModalBackdrop name="requestReportForm">
    <template slot="body">
      <div class="flex--column align--center text--center">
        <slot></slot>
        <BaseInput
          v-model="form.name"
          name="name"
          type="text"
          :hasError="$v.form.name.$error"
          label="Ваше имя"
          :error="$v.form.name"
          @blur="$v.form.name.$touch()"
          placeholder="Как вас зовут?"
        ></BaseInput>
        <BaseInput
          v-model="form.company_name"
          name="company_name"
          type="text"
          :hasError="$v.form.company_name.$error"
          label="Ваша компания"
          :error="$v.form.company_name"
          @blur="$v.form.company_name.$touch()"
          placeholder="Название вашей компании"
        ></BaseInput>
        <BaseInput
          v-model="form.phone"
          name="phone"
          type="text"
          :hasError="$v.form.phone.$error"
          label="Телефон"
          :error="$v.form.phone"
          @blur="$v.form.phone.$touch()"
          placeholder="+7 (____) - __ - __"
          mask="+7 (7##) ###-##-##"
        ></BaseInput>
        <BaseButton
          color="blue"
          :disabled="$v.$invalid"
          size="large"
          @click="onSubmit"
          class="form__button mt--1 ml--auto"
          >Отправить</BaseButton
        >
      </div>
    </template>
  </ModalBackdrop>
</template>

<script>
import ModalBackdrop from "@/components/common/ModalBackdrop.vue";
import { required, minLength } from "vuelidate/lib/validators";
import { saveInquiry } from "@/api/forms";

export default {
  components: {
    ModalBackdrop,
  },
  props: {
    description: {
      type: String,
      default:
        "Заполните форму ниже, чтобы узнать условия получения дополнительной аналитики:",
    },
    requestType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: null,
        company_name: null,
        phone: null,
      },
    };
  },
  validations: {
    form: {
      name: { required },
      company_name: { required },
      phone: {
        required,
        minLength: minLength(18),
      },
    },
  },
  methods: {
    async onSubmit() {
      if (!this.$v.$invalid) {
        try {
          this.isLoading = true;
          const payload = {
            request_type: this.requestType,
            name: this.form.name,
            phone: this.form.phone,
            company_name: this.form.company_name,
          };
          const response = await saveInquiry(payload);
          if (response.data.status != "ok") {
            throw new Error(response.data.message);
          }
          this.$modal.hide("requestReportForm");
          this.$toast.success("Заявка успешно отправлена!");
          return;
        } catch (error) {
          this.$toast.error(error.message);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
